import { create } from "zustand";
import { persist } from "zustand/middleware";

type AppConfigState = {
	isFirstTime: boolean;
	setIsFirstTime: (isFirstTime: boolean) => void;
};

export const useAppConfigStore = create<AppConfigState>()(
	persist(
		(set) => ({
			isFirstTime: true,
			setIsFirstTime: (isFirstTime) => set({ isFirstTime }),
		}),
		{
			name: "app-config-storage",
		},
	),
);
